import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-devis',
  templateUrl: './devis.component.html',
  styleUrls: ['./devis.component.scss'],
})
export class DevisComponent implements OnInit {
  article;
  client;
  clientData;
  me;
  searchUser;
  qte = 0;
  data;
  articleQuentity;
  listDevisAjout = [];
  @ViewChild('addCommand', { static: false }) addCommand;

  constructor(public generalService: GeneralService) {}
  logClient() {
    this.ajouterDocument();
  }
  ngOnInit(): void {}

  ajouterDocument() {
    var document = [
      {
        Tiers_code: this.client,
        Doc_Type: 'DEVIS',
        Doc_Num: '',
        Doc_ZONE: this.searchUser,
      },
    ];
    var documentD = this.listDevisAjout.map((e) => {
      return {
        DocD_Id: '',
        Art_Code: e.Art_Code,
        DocD_Q: e.quantite,
      };
    });

    var ds = {
      Document: document,
      DocumentD: documentD,
      ApiParam: [{ androidId: 123 }],
    };

    this.generalService.saveDA(ds).subscribe(() => {
      this.generalService.dialog.closeAll();
      this.generalService.dialogSuccess('Devis ajouter avec success', true);
    });
  }
  selectArticle() {
    this.generalService
      .rechercheTable2('API_VerifStock', this.article)
      .subscribe((res) => {
        this.articleQuentity = res[0].Stock;
      });
  }
  ChampEnter() {
    this.generalService
      .getDS('avtclient', this.client)
      .subscribe((res: any) => {
        this.clientData = res.Tiers[0];
      });
  }
  showAddModal() {
    this.generalService.dialog.open(this.addCommand);
  }
  searchCmdsByUsers() {
    // TODO Tbre
    this.generalService
      .rechercheTable('API_CMD', this.searchUser + ',DEVIS')
      .subscribe((res) => {
        console.log(res);
        this.data = res;
      });
  }
  addNewDevis() {
    this.generalService
      .rechercheTable2('articlef', this.article)
      .subscribe((res) => {
        this.listDevisAjout.push({ ...res[0], quantite: this.qte });
        this.article = null;
        this.qte = null;
      });
  }
  removeCommand(index) {
    this.listDevisAjout.splice(index, 1);
  }
}
